import { render, staticRenderFns } from "./loWrapper.vue?vue&type=template&id=106a412f&scoped=true&"
import script from "./loWrapper.vue?vue&type=script&lang=js&"
export * from "./loWrapper.vue?vue&type=script&lang=js&"
import style0 from "./loWrapper.vue?vue&type=style&index=0&id=106a412f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106a412f",
  null
  
)

export default component.exports